import { AxiosInstance } from 'axios';
import RedisApiAxiosInstance from 'services/api/RedisApiAxiosInstance/RedisApiAxiosInstance';
import { loadRemoteModule } from 'moduleFederation/moduleFederationRuntime';
import { Config } from '../../../../config';

type InitApiService = (axiosInstance: AxiosInstance, baseUrl: string | false) => void;

const initSubscriptionsMFEApiService = async () => {
  try {
    const { initSmApiService } = await loadRemoteModule<{ initSmApiService: InitApiService }>(
      'subscriptions/initApiService'
    );
    initSmApiService?.(RedisApiAxiosInstance, !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.SM);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('cannot load initSubscriptionsMFEApiService', e);
  }
};

export default initSubscriptionsMFEApiService;
